import React from 'react';
import { motion } from 'framer-motion';

/**
 * Shared section heading (eyebrow + title + accent rule + optional subtitle)
 * for the dark marketing sub-pages. Layout only — copy is supplied per page.
 */
const SectionHeading = ({ eyebrow, title, subtitle, align = 'center', className = '' }) => {
  const isCenter = align === 'center';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.6 }}
      className={`${isCenter ? 'mx-auto text-center' : ''} mb-12 max-w-3xl md:mb-16 ${className}`}
    >
      {eyebrow && (
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-red-500 sm:text-sm">
          {eyebrow}
        </p>
      )}
      <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
        {title}
      </h2>
      <div className={`mt-6 h-[3px] w-20 rounded-full bg-red-600 ${isCenter ? 'mx-auto' : ''}`} />
      {subtitle && (
        <p className={`mt-6 max-w-2xl text-base leading-relaxed text-gray-400 md:text-lg ${isCenter ? 'mx-auto' : ''}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeading;
